import { api } from 'data/api/api'
import { moneyObjectHeader } from 'data/api/money-object-header'

import { SavedSearchDto } from '../types/dtos/saved-search'

export type GetSortedSavedSearchesResp = {
  searches: Array<SavedSearchDto>
}

export const getSortedSavedSearches = (userId: number) =>
  api.get<GetSortedSavedSearchesResp>(`/users/${userId}/searches/sorted`, {
    headers: moneyObjectHeader,
  })
